const Routes = {
  Find: '/prospecter',
  MyClients: '/mes-clients',
};

export default Routes;
